import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class ReportDefault extends AbstractChart {
    protected preCreationOptions(): Options {
        const options = super.preCreationOptions();
        const data = options.data;
        const rowHeight = options.rowHeight;
        const yAxisTitle = options.yaxisTitle;
        const minYAxis = 1;
        const maxYAxis = 9;
        const marginTop = 40;
        const marginBottom = 10;
        const height = data.length * rowHeight + marginTop + marginBottom;
        const plotLinesWidth = 1;
        const plotLinesColor = 'white';
        let plotLinesXAxis: Array<XAxisPlotLinesOptions> = [];
        let plotLinesYAxis: Array<YAxisPlotLinesOptions> = [];
        let categoriesXAxis: Array<string> = [];
        for (let i = 0.5; i < data.length - 1; i++) {
            plotLinesXAxis.push({
                value: i,
                color: plotLinesColor,
                width: plotLinesWidth,
                zIndex: 1
            });
            categoriesXAxis.push(''); // We don't display categories. Add empty ones instead, which works better then using none.
        }
        for (let j = minYAxis + 1; j < maxYAxis; j++) {
            plotLinesYAxis.push({
                value: j,
                color: plotLinesColor,
                width: plotLinesWidth,
                zIndex: 1
            });
        }

        return super.mergeOptions(
            options, {
                chart: {
                    inverted: true,
                    width: 350,
                    marginLeft: 8,
                    marginRight: 8,
                    marginTop: marginTop,
                    marginBottom: marginBottom,
                    height: height,
                    style: {
                        fontFamily: '"proxima-nova", sans-serif'
                    }
                },
                plotOptions: {
                    series: {
                        animation: false
                    }
                },
                title: {
                    text: null
                },
                xAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: false
                    },
                    tickWidth: 0,
                    lineColor: '#ccd6eb',
                    plotLines: plotLinesXAxis,
                    categories: categoriesXAxis
                },
                yAxis: {
                    min: minYAxis,
                    max: maxYAxis,
                    tickInterval: 1,
                    opposite: true,
                    offset: -6,
                    title: {
                        text: yAxisTitle,
                        style: {
                            "color": "black",
                            "fontSize": "12px"
                        },
                        y: -3
                    },
                    labels: {
                        style: {
                            "color": "black",
                            "fontSize": "7pt"
                        }
                    },
                    plotBands: [
                        {
                            color: '#c1c1c1',
                            from: 1,
                            to: 3
                        }, {
                            color: '#d7d7d7',
                            from: 3,
                            to: 7
                        }, {
                            color: '#c1c1c1',
                            from: 7,
                            to: 9
                        }
                    ],
                    plotLines: plotLinesYAxis
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                series: [{
                    type: 'line',
                    color: '#fee6c5',
                    lineWidth: 2,
                    data: data,
                    marker: {
                        symbol: 'circle',
                        fillColor: '#e37165',
                        radius: 7,
                        lineWidth: 0,
                        lineColor: '#e37165'
                    }
                }]
            }
        );
    }
}

export default function () {registerPlugin(ReportDefault)}